/**
 * Component type identifiers for the ECS system
 */

export const ComponentTypes = {
  Position: 'Position',
  Movement: 'Movement',
  Health: 'Health',
  Combat: 'Combat',
  Faction: 'Faction',
  Unit: 'Unit',
  Building: 'Building',
  Spawner: 'Spawner',
  Render: 'Render',
  Territory: 'Territory',
  Collider: 'Collider',
  Wall: 'Wall',
} as const;

export type ComponentType = typeof ComponentTypes[keyof typeof ComponentTypes];
